function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".58",
  d: "M24 0H0v24h24V0z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M21 7v5l-4 2.78V9.23L21 7zm-9 10.56V22l-9-5 4-2.23v.01l5 2.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 9.23v5.54L3 17V7l4 2.23z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M12 2v4.44L7 9.22v.01L3 7l9-5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 9.23v-.01l-5-2.78V2l9 5-4 2.23zm0 5.55v4.72L12 22v-4.44l5-2.78z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21 17v5l-4-2.5v-4.72L21 17zm-4-7.78v5.56l-5 2.78-5-2.78V9.22l5-2.78 5 2.78z"
})));